
<template>
  <div class="login">
    <v-card style="padding: 20px" class="mx-auto mt-5">
      <v-card-title>
        <span style="color:darkgreen;" class="label18">Enroll as a new participant</span>
      </v-card-title>

      <v-card-text style="margin-top:16px;">
        <v-form autocomplete="off">

          <br>
          <v-card-text style="margin-top:12px;">
            Select your initial flight. Tournament Chairman can adjust your flight.<br/>
            <span class="label16" style="display:inline-block;width:120px">Default Flight: </span>
            <select class="dropdown" v-model="player.defaultFlight">
              <option value="Select Flight">Select Flight</option>
              <option value="Nicklaus">Nicklaus (Handicap ≤0-7.99)</option>
              <option value="Palmer">Palmer (Handicap 8-15.99</option>
              <option value="Hogan">Hogan (Handicap 16-30+)</option>
            </select>
          </v-card-text>

          <br>

          <v-card-text style="margin-top:12px;">
            <span class="label16" style="display:inline-block;width:120px">Shirt Size: </span>
            <select class="dropdown" v-model="player.shirtSize">
              <option value="Select Size">Select Size</option>
              <option value="X-Small">X-Small</option>
              <option value="Small">Small</option>
              <option value="Medium">Medium</option>
              <option value="Large">Large</option>
              <option value="X-Large">X-Large</option>
            </select>
          </v-card-text>

          <v-text-field label="First Name" v-model="player.firstName"/>
          <v-text-field label="Middle Name" v-model="player.middleName"/>
          <v-text-field label="Last Name" v-model="player.lastName"/>
          <v-text-field label="Nick Name" v-model="player.nickName"/>
          <v-text-field label="Email Address" v-model="player.emailAddress"/>
          <v-text-field label="Cell Phone" v-model="player.cellPhone" placeholder="###-###-####"/>


          <v-text-field label="Preferred Username" v-model="player.userid"/>
          <v-text-field
                  v-model="player.password"
                  label="Password"
                  :type="showPassword ? 'text' : 'password'"
                  prepend-icon="mdi-lock"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showPassword = !showPassword"
          />

          <v-text-field
                  v-model="confirmPassword"
                  label="Confirm Password"
                  :type="showPassword ? 'text' : 'password'"
                  prepend-icon="mdi-lock"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showPassword = !showPassword"
          />
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn style="background-color:darkgreen;color:white;" @click="formSubmit()">Submit</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import swal from 'sweetalert';

  export default {
    name: "login",
    data: () => ({
      showPassword: false,
      player: {
        firstName: '',
        middleName: '',
        lastName: '',
        nickName: '',
        cellPhone: '',
        emailAddress: '',
        defaultFlight: 'Select Flight',
        shirtSize: 'Select Size',
        userid: '',
        password: ''
      },
      confirmPassword: ''
    }),
    methods: {
      forgotPassword: function() {
        console.log('FORGOTy PASSWORD');
      },
      validate: function() {
        var valid = false;
        var errorMsg = '';

        if (this.player.firstName === '') {
          errorMsg = 'First Name is empty';
        } else if (this.player.middleName === '') {
          errorMsg = 'Middle Name is empty';
        } else if (this.player.lastName === '') {
          errorMsg = 'Last Name is empty';
        } else if (this.player.cellPhone === '') {
          errorMsg = 'Phone is empty';
        } else if (this.player.emailAddress === '') {
          errorMsg = 'Email Address is empty';
        } else if (this.player.userid === '') {
          errorMsg = 'Userid is empty';
        } else if (this.player.defaultFlight === 'Select Flight') {
          errorMsg = 'Must select a flight';
        } else if (this.player.shirtSize === 'Select Size') {
          errorMsg = 'Must select a Shirt Size';
        } else if (this.player.password === '') {
          errorMsg = 'Password is empty';
        } else if (/[#&%^ ]/.test(this.player.password)) {
          errorMsg = 'Password cannot have [#, &, %, ^, space] characters.';
        } else if (this.player.password !== this.confirmPassword) {
          errorMsg = 'Password and Confirm password do not match.';
        } else {
          valid = true;
        }

        if (!valid) {
          swal("Invalid", errorMsg, "info");
        } else {
          return valid;
        }
      },
      formSubmit() {
          if (this.validate()) {
            this.axios.post('/public/players/enroll', this.player)
            .then(function (response) {
                window.location.href  = '/signin';
            })
            .catch(function (error) {
                swal("Error", "Username or email address already been used.", "error");
                console.log('ERROR: ' + error);
            });

            this.confirmPassword = '';
          }
      }
    }
  }
</script>

<style scoped>
  .v-card {
    background-color: #e6f2ea;
  }

  .login {
    margin-top: 5px;
    width: 100%;
  }

  .dropdown {
    padding: 5px 10px !important;
  }

  @media (min-width: 768px) {

  }

</style>